import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  IconButton,
  Tooltip,
  Chip,
  TablePagination,
} from "@mui/material";
import {
  FaEye,
  FaEdit,
  FaTrash,
  FaPlus,
  FaSearch,
  FaUsers,
  FaImages,
  FaUserShield,
} from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";

import Modal from "../../../components/Modal/Modal";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import { gbState } from "../../../components/shared/GlobalState";
import FamilyView from "./FamilyView";

const FamilyListChild = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [data, setData] = useState([]);
  const [serverData, setServerData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  //Error Logging Service
  const [{ errorLogApi, user }] = useAtom(gbState);

  const handleDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure to delete this Family ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecord = (id) => {
    let userToken = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${userToken}` },
    };
    axios
      .delete(`${process.env.REACT_APP_API_URL}/family/delete/${id}`, config)
      .then((response) => {
        // alert(JSON.stringify(response));
        getDataFromServer();
      })
      .catch((err) => {
        errorLogApi(err, "FamilyListChild", "/family/delete");
      });
  };

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/family/${user.church_id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data.users));
        const oldData = response.data.families;
        setServerData(oldData);
        const updatedData = oldData.map((data) => {
          return {
            ...data,
            id: data?._id,
            family_code: data?.family_code,
            family_name: data?.family_name,
            primary_member:
              data?.primary_member_id?.first_name +
              " " +
              data?.primary_member_id?.last_name,
            mobile: data?.primary_member_id?.mobile,
            email: data?.primary_member_id?.email,
            city: data?.city?.label || "",
            state: data?.state?.label || "",
            status: data?.deceased_status,
            account_status: data?.primary_member_id?.account_status,
            deceased_status: data?.deceased_status,
            gender: data?.gender,
            country: data?.country?.label || "",
            blood_group: data?.blood_group,
            qualification: data?.qualification,
            birth_place: data?.birth_place,
          };
        });

        setData(updatedData);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/family/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data.users));
          const oldData = response.data.families;
          const updatedData = oldData.map((data) => {
            return {
              ...data,
              id: data?._id,
              family_code: data?.family_code,
              family_name: data?.family_name,
              primary_member:
                data?.primary_member_id?.first_name +
                " " +
                data?.primary_member_id?.last_name,
              mobile: data?.primary_member_id?.mobile,
              email: data?.primary_member_id?.email,
              city: data?.city?.label || "",
              state: data?.state?.label || "",
              status: data?.deceased_status,
              account_status: data?.primary_member_id?.account_status,
              deceased_status: data?.deceased_status,
              gender: data?.gender,
              country: data?.country?.label || "",
              blood_group: data?.blood_group,
              qualification: data?.qualification,
              birth_place: data?.birth_place,
            };
          });

          setData(updatedData);
        })
        .catch(function (err) {
          console.log("error api call ", err);
        });
    };
    getDataFromServer();
  }, []);

  const columns = [
    { id: "action", label: "Action", minWidth: 100 },
    { id: "family_code", label: "Family Code", minWidth: 100 },
    { id: "family_name", label: "Family Name", minWidth: 140 },
    { id: "primary_member", label: "Primary Member", minWidth: 170 },
    { id: "mobile", label: "Mobile", minWidth: 130 },
    { id: "status", label: "Status", minWidth: 100 },
    { id: "city", label: "City", minWidth: 130 },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredData = useMemo(() => {
    return data.filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [data, searchTerm]);

  const paginatedData = useMemo(() => {
    const startIndex = page * rowsPerPage;
    return filteredData.slice(startIndex, startIndex + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  const handleDelegateAdmin = (user) => {
    confirmAlert({
      title: "Confirm Action",
      message: "Are you sure you want to delegate this user as Church Admin?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            console.log(user);
            let userToken = localStorage.getItem("token");
            const config = {
              method: "post",
              url: `${process.env.REACT_APP_API_URL}/user/update-secondary-role`,
              headers: {
                Authorization: `Bearer ${userToken}`,
              },
              data: { userId: user?._id, secondaryRole: "CHURCH_ADMIN" },
            };
            axios(config)
              .then(function (response) {
                console.log(response);
                getDataFromServer();
              })
              .catch(function (err) {
                console.log(err);
              });
          },
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const handleRemoveAdmin = (user) => {
    confirmAlert({
      title: "Confirm Action",
      message: "Are you sure you want to Remove this Admin Rights?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            console.log(user);
            let userToken = localStorage.getItem("token");
            const config = {
              method: "post",
              url: `${process.env.REACT_APP_API_URL}/user/remove-secondary-role`,
              headers: {
                Authorization: `Bearer ${userToken}`,
              },
              data: { userId: user?._id },
            };
            axios(config)
              .then(function (response) {
                console.log(response);
                getDataFromServer();
              })
              .catch(function (err) {
                console.log(err);
              });
          },
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  return (
    <div className="w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Church Families</h2>
        <Button
          variant="contained"
          color="primary"
          startIcon={<FaPlus />}
          onClick={() => navigate("/family/add")}
        >
          Add Family
        </Button>
      </div>

      <div className="mb-4">
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search families..."
          InputProps={{
            startAdornment: <FaSearch className="mr-2 text-gray-400" />,
          }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row) => (
              <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                <TableCell>
                  <div className="flex items-center space-x-1">
                    <Tooltip title="View details">
                      <IconButton
                        size="small"
                        onClick={() => {
                          toggleModal();
                          setCurrentRecord(row);
                        }}
                      >
                        <FaEye className="text-blue-600" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={() =>
                          navigate("/family/update", { state: row })
                        }
                      >
                        <FaEdit className="text-gray-600" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Add Family Member">
                      <IconButton
                        size="small"
                        onClick={() =>
                          navigate("/family/member/add", { state: row })
                        }
                      >
                        <FaUsers className="text-green-600" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Add Family Album">
                      <IconButton
                        size="small"
                        onClick={() =>
                          navigate("/family/member/addAlbum", { state: row })
                        }
                      >
                        <FaImages className="text-purple-600" />
                      </IconButton>
                    </Tooltip>
                    {row?.primary_member_id?.secondary_role ? (
                      <Tooltip title="Remove admin rights">
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleRemoveAdmin(row?.primary_member_id)
                          }
                        >
                          <FaUserShield className="text-red-600" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Delegate Admin rights">
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleDelegateAdmin(row?.primary_member_id)
                          }
                        >
                          <FaUserShield className="text-gray-600" />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(row.id)}
                      >
                        <FaTrash className="text-red-600" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
                <TableCell>{row.family_code}</TableCell>
                <TableCell>{row.family_name}</TableCell>
                <TableCell>{row.primary_member}</TableCell>
                <TableCell>{row.mobile}</TableCell>
                <TableCell>
                  <Chip
                    label={row.deceased_status ? "Deceased" : "Active"}
                    color={row.deceased_status ? "error" : "success"}
                    size="small"
                  />
                </TableCell>
                <TableCell>{row.city}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <ErrorBoundaryRoutes route="/family" page="ModalView">
        {showModal && (
          <Modal onClose={toggleModal}>
            <h2 className="mb-4 text-xl font-bold">Family Details</h2>
            <FamilyView currentRecord={currentRecord} />
          </Modal>
        )}
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default FamilyListChild;
